import { API_ENDPOINTS } from '@/config/endpoints'
import { getProxiedUrl } from '@/utils/proxy'
import type { HaloPostsResponse, HaloTagsResponse, HaloCategoriesResponse } from '@/types/api'

async function fetchJSON<T>(url: string): Promise<T | null> {
  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    return await response.json() as T
  } catch (error) {
    console.error(`请求失败: ${url}`, error)
    return null
  }
}

function getApiUrl(baseURL: string, endpoint: string): string {
  return getProxiedUrl(`${baseURL}${endpoint}`)
}

export function fetchPosts(baseURL: string): Promise<HaloPostsResponse | null> {
  return fetchJSON<HaloPostsResponse>(getApiUrl(baseURL, API_ENDPOINTS.posts))
}

export function fetchTags(baseURL: string): Promise<HaloTagsResponse | null> {
  return fetchJSON<HaloTagsResponse>(getApiUrl(baseURL, API_ENDPOINTS.tags))
}

export function fetchCategories(baseURL: string): Promise<HaloCategoriesResponse | null> {
  return fetchJSON<HaloCategoriesResponse>(getApiUrl(baseURL, API_ENDPOINTS.categories))
}
